export default __webpack_public_path__ + "static/media/checked.238ac39d.svg";